<template>
  <div
    class="tasklist-toolbar d-flex align-center justify-end flex-wrap"
    data-testid="tasklist__list-toolbar"
  >
    <div class="tasklist-toolbar__status-group d-flex align-center">
      <span class="tasklist-toolbar__status-label" data-testid="tasklist__status-label">Status :</span>
      <PipelineStatusChips
        :loading="loading"
        :metadata="metadata"
        :selected-tab-stage="selectedTabStage"
        :active-summary="activeSummary"
        @select-stage="$emit('select-stage', $event)"
      />
    </div>

    <div class="tasklist-toolbar__divider" aria-hidden="true" />

    <TasklistToolbarActions
      :has-active-table-filter="hasActiveTableFilter"
      :column-order-changed="columnOrderChanged"
      :loading="loading"
      :metadata="metadata"
      :over-due-date="overDueDate"
      :table-headers-filter="tableHeadersFilter"
      :page_name="pageName"
      :show-conversation="showConversation"
      @clear-filter="$emit('clear-filter')"
      @save-column-order="$emit('save-column-order')"
      @overdue-filter="$emit('overdue-filter')"
      @mark-conversation-read="$emit('mark-conversation-read')"
      @bulk-action="$emit('bulk-action', $event)"
      @bulk-update-duedate="$emit('bulk-update-duedate')"
      @bulk-edit-threshold="$emit('bulk-edit-threshold')"
      @bulk-edit-tasks="$emit('bulk-edit-tasks')"
      @bulk-unlink-bot="$emit('bulk-unlink-bot')"
      @bulk-download="$emit('bulk-download')"
      @bulk-change-status="$emit('bulk-change-status', $event)"
      @apply-columns="$emit('apply-columns', $event)"
      @save-columns="$emit('save-columns', $event)"
      data-testid="tasklist__toolbar-actions"
    />
  </div>
</template>

<script>
import './TasklistToolbar.scss';
import { PipelineStatusChips } from '../../../../../components';
import TasklistToolbarActions from '../TasklistToolbarActions/TasklistToolbarActions.vue';

export default {
  name: 'TasklistToolbar',
  components: {
    PipelineStatusChips,
    TasklistToolbarActions,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    metadata: {
      type: Object,
      default: () => ({}),
    },
    selectedTabStage: {
      type: [Number, String],
      default: null,
    },
    activeSummary: {
      type: Object,
      default: () => ({}),
    },
    hasActiveTableFilter: {
      type: Boolean,
      default: false,
    },
    columnOrderChanged: {
      type: Boolean,
      default: false,
    },
    selectedTasks: {
      type: Array,
      default: () => [],
    },
    userType: {
      type: String,
      default: 'preparer',
    },
    overDueDate: {
      type: Boolean,
      default: false,
    },
    tableHeadersFilter: {
      type: Array,
      default: () => [],
    },
    pageName: {
      type: String,
      default: 'tasklist',
    },
    showConversation: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
